// extracted by mini-css-extract-plugin
export default {"item-img":"CartProductItem_item-img__18a8R","img-title":"CartProductItem_img-title__2paLa"};